import { BUTTON_TYPES } from "@CubeComponents/constants/globalVariable";
import ButtonComponent from "@CubeComponents/form/ButtonComponent";
import Text from "@CubeComponents/html/Text/Text";
import IconComponent from "@CubeComponents/icons";
import { getNoAccessPage } from "@Features/estimation/components/Estimation/BoqHelper";
import { getEstimateUrl } from "@Features/projects/utils/projectUrls";
import { errorCodes } from "@Helpers/errorCodes";
import { RootState } from "@Reducers/index";
import { useTranslation } from "@i18n";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";

const EstimateNotFoundPage = ({ projectId }: { projectId: string }) => {
  const estimateError = useSelector((state: RootState) => state.estimateError);
  const navigate = useNavigate();
  const { t } = useTranslation();

  const handleClick = () => {
    const url = getEstimateUrl({
      projectId,
      estimateList: true,
    });
    navigate(url);
  };

  return estimateError === errorCodes.ESTIMATE_NO_ACCESS ? (
    getNoAccessPage("Estimate")
  ) : (
    <div className="w-full h-full flex items-center justify-center overflow-auto">
      <div className="flex flex-col w-100 gap-8 items-center justify-between">
        <IconComponent name="404Illustration" width="22.5625rem" height="19rem" />
        <div className="flex flex-col gap-4 text-center">
          <Text sx={{ whiteSpace: "normal" }} className="text-2xl font-semibold text-text_light">
            {t("This Estimate was deleted")}
          </Text>
          <Text sx={{ whiteSpace: "normal" }} className="text-lg ">
            {t("Please check the entered URL as the Estimate you’re trying to access is no longer available.")}
          </Text>
          <div>
            <ButtonComponent buttonType={BUTTON_TYPES.BACKGROUND_BUTTON} onClick={handleClick}>
              <Text>{t("View all Estimates")}</Text>
            </ButtonComponent>
          </div>
        </div>
      </div>
    </div>
  );
};

export default EstimateNotFoundPage;
